import emailReportsList from './modules/store'

export const modules = {
  emailReportsList
}



// WEBPACK FOOTER //
// ./src/store/EmailReports/index.js